require('./release/angular-focus.js');
module.exports = 'Focus.Service';
